import { Link } from "react-router-dom";

const shortcuts = [
  {
    key: "tv",
    name: "电视剧",
    desc: "古装、悬疑、都市、年代，热门剧集一站追",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20a%20large%20screen%20playing%20a%20drama%2C%20warm%20amber%20lamp%20light%20and%20deep%20navy%20evening%20shadows%2C%20modern%20editorial%20style%2C%20high%20detail&width=600&height=400&seq=cat-tv-01&orientation=landscape",
  },
  {
    key: "movie",
    name: "电影",
    desc: "院线佳作与口碑之作，每一次观影都值得",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Classic%20cinema%20hall%20with%20red%20velvet%20seats%20and%20warm%20amber%20screen%20light%20in%20deep%20navy%20darkness%2C%20editorial%20style%2C%20high%20detail&width=600&height=400&seq=cat-movie-01&orientation=landscape",
  },
  {
    key: "classic",
    name: "经典影视",
    desc: "历久弥新的好故事，值得反复品味",
    icon: "ri-award-line",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20a%20projector%20on%20a%20wooden%20table%20under%20warm%20amber%20light%20with%20deep%20navy%20shadows%2C%20editorial%20style%2C%20high%20detail&width=600&height=400&seq=cat-classic-01&orientation=landscape",
  },
];

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {shortcuts.map((item) => (
        <Link
          key={item.key}
          to={`/category/${item.key}`}
          className="group relative rounded-lg overflow-hidden h-44 md:h-52 cursor-pointer"
        >
          <img
            src={item.image}
            alt={`${item.name}分类`}
            title={`${item.name} - 赏金女王影视大全`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/50 to-primary-950/20" />
          <div className="relative h-full flex flex-col justify-end p-4 md:p-5">
            <span className="w-10 h-10 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center text-xl mb-3">
              <i className={item.icon} aria-hidden="true"></i>
            </span>
            <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">{item.name}</h3>
            <p className="mt-1 text-xs md:text-sm text-background-100/85 line-clamp-2">{item.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}